import React, { useEffect, useState, useRef} from "react"; // Keep it here for React to Work.
import { Routes, Route, useNavigate } from "react-router-dom";
import './styles/styleImporter.css';


import AccessControlInspector from "./serviceLayer/authorization/AccessControlInspector";
import RoleBasedAccessControlOrigin from "./utils/stringLiterals/RoleBasedAccessControlOrigin";
import SessionService from "./serviceLayer/session/SessionService";
import SessionManager from "./businessLayer/managers/SessionManager";
import SessionConfiguration from "./utils/configuration/SessionConfiguration";
//Route Protection
import ResourceProtector from "./presentationLayer/components/routeProtection/ResourceProtector";

//Public webpages Components
import Registration from "./presentationLayer/pages/public/Registration";
import Login from "./presentationLayer/pages/public/Login";
import Logout from "./presentationLayer/pages/public/Logout";
import NotFound from "./presentationLayer/pages/public/NotFound";


//Private webpages Components
import Main from "./presentationLayer/pages/private/Main";
import Questionnaire from "./presentationLayer/pages/private/Questionnaire";
import QuestionnaireSubmission from "./presentationLayer/pages/private/QuestionnaireSubmission";
import QuestionnaireReport from "./presentationLayer/pages/private/QuestionnaireReport";
import MyProfile from "./presentationLayer/pages/private/AppConfiguration/MyProfile";



export default function App(){
    //console.log("Application Component Activated");
    const [allResources, setAllResources] = useState([]);
    const [loading, setLoading] = useState(true);

    const navigate = useNavigate();
    const [session, setSession] = useState(null);
    const timerRef = useRef(null);

    useEffect(()=>{
        async function loadResources() { 
            try {
                const resources = await AccessControlInspector.getAllresourcesFromAPIAsync(RoleBasedAccessControlOrigin.customer); 
                setAllResources(resources); 
            } catch (err) { 
                console.error("Error loading resources:", err); 
                setAllResources([]); 
            } finally { 
                setLoading(false); 
            } 
        }
        loadResources();
    },[]);

    useEffect(()=>{
        //console.log("app-useEffect-allResources", allResources);
    }, [allResources]);

    
    useEffect(()=>{
        //Run initial check
        validateSession();

        const handleActivity = function(){
            if(document.visibilityState === 'visible'){
                validateSession();
            }
        }

        window.addEventListener('visibilitychange', handleActivity);
        window.addEventListener('focus', handleActivity);

        return () => {
            window.removeEventListener('visibilitychange', handleActivity);
            window.removeEventListener('focus', handleActivity);
            if (timerRef.current) clearTimeout(timerRef.current);
        };
        // Since validateSession is a regular function inside the component,
        // we don't include it in deps to avoid infinite loops, 
        // or we move it outside (as seen with getStoredSession).
    },[]);

     function clearSession(){
        SessionService.removeSession();
        setSession(null);
        if(timerRef.current){
            clearTimeout(timerRef.current);
            timerRef.current = null;
        }

        SessionManager.exitApplication(logoutCallback);
    }

     function validateSession(){
        const data = SessionService.getStoredSessionData();
        //console.log("validateSession-data", data );
        if(!data ){
            if(session){
                setSession(null);
            }
            
            return; 
        }

        const elapsetTime = (Date.now() - data.startTime);
        //console.log("validateSession-elapsedTime", elapsetTime);

        if(elapsetTime >= SessionConfiguration.SESSION_LIMIT){
            clearSession();
        }
        else{
            //Update state only if it is a new Session ID
            if(!session || session.id !== data.id){
                setSession(data);
            }

            //Refresh the timer
            if(timerRef.current){
                clearTimeout(timerRef.current);
            }
            const remainingTime = (SessionConfiguration.SESSION_LIMIT - elapsetTime);
            timerRef.current = setTimeout(()=>{
                clearSession();
            }, remainingTime);
        }
    }

    //#region Private Functions BEGIN

    function logoutCallback(httpResponse) {
        //console.log("logoutCallback-httpResponse", httpResponse);       
        return navigate("/public/logout", { 
            state: { from: location.pathname },
            replace: true 
        });               
    }

    //#region Private Functions END
    

    //console.log("App Loaded Correctly");
    return(
    <>
        {loading && <p>Loading…</p>}
        {!loading &&       
        <div className ="app">
            <Routes>
                {/****General Public routes with No Protection *****/}
                <Route path="/" element={<Registration/>}/>
                <Route path="/public/registration" element={<Registration/>}/>
                <Route path="/public/login" element={<Login />} />
                <Route path="/public/logout" element={<Logout/>} />

                {/****Private RESOURCE PAGES with Auth Protection *****/}
                <Route path="/private/main" element={<ResourceProtector children={<Main resource={allResources._main} />} resource={allResources._main} rejectionRoute="/public/logout"/> }/>
                <Route path="/private/questionnaire" element={<ResourceProtector children={  <Questionnaire resource={allResources._questionnaire} />} resource={allResources._questionnaire} rejectionRoute="/private/main" />} />
                <Route path="/private/questionnaire/submission" element={<ResourceProtector children={  <QuestionnaireSubmission resource={allResources._questionnaire}/>} resource={allResources._questionnaire} rejectionRoute="/private/main" />} />
                <Route path="/private/questionnaire/report" element={<ResourceProtector children={ <QuestionnaireReport resource={allResources._questionnaire_report}/>} resource={allResources._questionnaire_report} rejectionRoute="/private/main" />} />
                <Route path="/private/appconfiguration/myprofile" element={<ResourceProtector children={<MyProfile resource={allResources._my_profile}/>} resource={allResources._my_profile} rejectionRoute="/private/main" />} />

                {/****Private ACTION PAGES with Auth Protection *****/}

                {/****Private GENERAL PRIVATE PAGES FOR ALL CUSTOMERS with Session Protection *****/}
                


                {/****Catch-all route for any other path with No Protection ****/}
                <Route path="*" element={<NotFound />} />
            </Routes>
        </div>}
    </>
    );
}
